/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_SchuelertypInputs */

const de__field_schuelertyp = /** @type {(inputs: _Field_SchuelertypInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unter-/Oberstufe`)
};

/**

* @param {_Field_SchuelertypInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_schuelertyp = /** @type {((inputs?: _Field_SchuelertypInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_SchuelertypInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_schuelertyp(inputs)
});